module.exports = __webpack_public_path__ + "img/MEDIA041.6d48e137.jpg";